import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAttention = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4.364 4.364a7.97 7.97 0 1 1 11.272 11.272A7.97 7.97 0 0 1 4.364 4.364M10 3.529a6.47 6.47 0 1 0 0 12.942 6.47 6.47 0 0 0 0-12.942m0 5.721a.75.75 0 0 1 .75.75v3.61a.75.75 0 0 1-1.5 0V10a.75.75 0 0 1 .75-.75m-.46-3.157a1.01 1.01 0 1 1 1.122 1.68 1.01 1.01 0 0 1-1.122-1.68"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAttention;
